module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch7"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Everybody’s Talkin’ at Me")])])]), _vm._v(" "), _c('p', {
    staticClass: "DL"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("11:20 a.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("You would think a dead bird outside your Spanish class window would be the low point of your day, but it’s not. Things only go more downhill from there. Monday is an odd day, meaning we only have periods one, three, five, and seven. In fifth-period U.S. history, we have a quiz. A quiz I knew about. A quiz I totally forgot to study for due to my attention being elsewhere. Namely on my fight with Tristan.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("And it’s not one of those essay-style quizzes you can just wing by being vague and witty. It’s ten multiple choice questions about the American Revolution, a chapter in our textbook that I did "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("not")]), _vm._v(" read. I pretty much guess on every single question. I figure I have a twenty-percent chance of getting them right.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("After we’re finished, Mr. Weylan—hands down the oldest man alive (I think he actually lived "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("through")]), _vm._v(" the American Revolution)—has us swap quizzes with our neighbors so we can grade each other’s.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Needless to say, I bombed it. So much for my twenty-percent odds.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I didn’t even get one question right.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Now, the odds of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("that")]), _vm._v(" have to be pretty impressive.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Daphne Gray—yes, the same Daphne Gray who threw the party where Tristan and I first met—scribbles a big fat zero on the top of my quiz, beside which she draws a smiley face.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She tilts her head. “Better luck next time, Sparks.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("You know that voice people use when they want you to know for certain that they’re being insincere? That’s Daphne’s voice as she slides the quiz onto my desk. Like it brings her immense pleasure to watch me fail.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Here’s the thing. Before I started dating Tristan, girls like Daphne Gray didn’t even know my name. She never would have given me a second thought. Before that party at her house, Owen and I just kind of existed in our little universe, and that was fine with me. I’ve never been one of those girls who aspired to higher social status. Being popular wasn’t on my bucket list. But the moment word got out that Tristan and I were a couple, it was like someone dressed me up in a silly costume and shone a giant spotlight on my face. Suddenly people knew my name. They knew where I lived. They knew my class schedule.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Girls like Daphne Gray suddenly took notice. And not in a good way. They noticed me the way a supermodel notices a pimple that’s just appeared on her face hours before a photo shoot.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Now I constantly feel like I’m locked in a display case. Like one of those caveman exhibits at the museum that curious groups of kids walk by, laughing at the skimpy rabbit-fur clothing that hides practically nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I feel like I’m permanently trapped in the naked-at-school dream.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("As Mr. Weylan writes our homework assignment on the board—read chapters 3 and 4 in our textbooks—I carefully stow the quiz away in my binder under the divider tab marked “History” and the sub-divider tab marked “Tests and Quizzes.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I’ll have to figure out how to fix this later. Maybe I can convince Mr. Weylan to give me some extra-credit work. If I can speak loudly enough for his hearing aid to pick up.")]), _vm._v(" "), _c('p', {
    staticClass: "DL2"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("12:40 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("By lunch, I’m absolutely starving, but I’m way too nervous about the upcoming election speeches to keep anything down. I completely forgot to eat my peanut butter toast this morning and I find it crumpled at the bottom of my schoolbag, the peanut butter now creating an adhesive between my chemistry textbook and my extra-credit paper for English.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Perfect.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("At least I had the foresight to store the note cards for my election speech in the interior Velcro-sealed pocket. The speeches are after lunch during homeroom, and I haven’t even so much as glanced at the notes all day. Remind me again why I agreed to be Rhiannon Marshall’s running mate. Because she asked? No, there had to be a better reason than that. I’d like to think that I was even halfway rational when I decided to say yes. Maybe something about college applications? It’s all a blur now.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I pull the cards Rhiannon wrote for me out of my bag and slip them into the back pocket of my skinny jeans. I’ll review them a few times during lunch and everything will be fine.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I’m a quick study.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It’s the standing-up-in-front-of-fifteen-hundred-people part that’s making my internal organs do cartwheels.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Ever since school started last month, I’ve been eating my lunches in the band room while Tristan and the guys rehearse. I try to practice my speech in there, but I’m way too distracted by Tristan’s sexy voice as he croons the lyrics to their most popular song, “Mind of the Girl,” and I eventually leave to find somewhere quiet.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The library is my best bet. When I enter, Owen is leading the book club in a passionate debate about the major differences between the movie and book versions of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Book Thief")]), _vm._v(". I steal up the stairs to the second floor and lock myself into one of the tiny soundproof booths where language arts students record the oral portions of their exams.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Even in the dead silence of this little cell, I still can’t seem to concentrate. I stare numbly at my index cards, but the more I try to focus on Rhiannon’s neat handwriting, the more the letters blur and swim in my vision. I’m able to make out words like “vision” and “commitment” and “campaign,” but I can’t, for the life of me, make them fit together into any coherent thoughts.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("What am I going to do? I can’t even read the stupid speech! How am I ever supposed to "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("give")]), _vm._v(" the stupid speech?")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Eventually, I give up and proceed back downstairs. I sit atop one of the tables and wait for Owen. When book club wraps up, he comes over and slides onto the table across from me, swinging his legs like a little kid sitting on a too-high stool.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You should join book club,” he says, holding up his tattered, dog-eared copy of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Book Thief")]), _vm._v(". “And by the way, I totally stole this book.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I stifle a laugh. “No, you didn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“How do you know?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Because you only pretend to be a rebel. Deep down inside, you’re just like me.” I bat my eyes. “Sugar and spice and all things nice.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Owen pulls a half-eaten sandwich from his bag, unwraps it, and holds it out to me. The smell of the tuna makes my stomach turn and I breathe through my mouth. “No, thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You haven’t eaten anything all day.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“How do you know?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I know things.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I cross my arms, demanding a better explanation.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You never eat when you’re nervous.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Who says I’m nervous?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He doesn’t answer. Instead he tries to shove the sandwich into my face again. I turn away and gag.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You have to eat "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("something")]), _vm._v(",” he says. “You can’t get up in front of the entire school on an empty stomach. What if you faint?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“At least then I won’t have to give this speech.” I flash a smile and fan myself coyly with the index cards still clutched in my hands.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Owen reaches out and snatches them. “Let me see those.” He flips through a few cards and makes a horrified face. “Did you write this? It’s horrible!”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I pretend to be insulted. “What if I did?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He hands the cards back to me. “You didn’t. You would never write anything this bland.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I flip through the cards. “Is it really bland?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“This speech makes vanilla look like the flavor of the month.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Rhiannon Marshall wrote it.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Ah, see, now that explains everything. Why didn’t you write your own speech?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I shrug. “I dunno. She offered to write it and I agreed. Besides, she’s the one running for president. I’m only her VP. It’s kind of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("her")]), _vm._v(" platform.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yeah, but it’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("your")]), _vm._v(" face everyone has to look at while you give this awful speech. I mean, it reads like she copied it from the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Most Overused School Election Speeches")]), _vm._v(" book.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“That book doesn’t exist.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He taps the cards in my hand. “It does now.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I glance at the clock on the wall. Two minutes and counting. My heart races. “Did you know that the number-one fear in America is public speaking?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What’s number two?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Death.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He bursts out laughing, eliciting a few glares from students trying to study. “Are you saying that the average American would rather drive off a cliff than give a speech?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“That’s what I’m saying.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The bell rings and I glance up at the speaker, like a convicted witch looking at the stake that’s about to burn her.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Well, you’re not dying today,” Owen says, sliding off the table and standing in front of me. “Not on my watch. Let’s go.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I slump forward, resting my head against his chest. His body tenses for a moment, as though I took him by surprise, but then he relaxes and pats me on the back. “You’ll be fine. You’ll give the world’s most clichéd speech, everyone will fall asleep, and then it’ll be over.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I lift my head and look up at him. “Owen?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He smiles. It’s not his usual goofy smile. It almost looks forced. “Yeah?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You’re absolutely horrible at pep talks.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("And then it’s back. The boyish grin I’ve come to love. He bows like a gentleman in a Jane Austen novel. “Glad I could be of service.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1eb733e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter7.vue
// module id = 93
// module chunks = 0